<template>
  <v-row v-if="loading === true">
    <v-col>
      {{ $t('Loading') }}
      <p/>
      <v-progress-linear
        v-if="linear"
        indeterminate
        color="orange darken-2"
      ></v-progress-linear>
      <v-skeleton-loader
        v-else
        :loading="load"
        :transition="transition"
        :height="height"
        type="article"
      ></v-skeleton-loader>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'PanelLoading',
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    flat: {
      type: Boolean,
      required: false,
      default: false
    },
    linear: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      load: '',
      transition: ''
    }
  },
  computed: {
    height () {
      return this.flat ? '100' : 450
    }
  }
}
</script>
